const isApple = /mac|iphone|ipad|ipod/i.test(navigator.userAgent)

export function shortcutLabel(key: string) {
  return isApple ? `⌘${key}` : `Ctrl+${key}`
}
